var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArticlePage',{attrs:{"page":"download","content":_vm.content,"show-mobile-download":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }